import { render, staticRenderFns } from "./htcgList.vue?vue&type=template&id=65baa89f&scoped=true"
import script from "./htcgList.vue?vue&type=script&lang=js"
export * from "./htcgList.vue?vue&type=script&lang=js"
import style0 from "./htcgList.vue?vue&type=style&index=0&id=65baa89f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65baa89f",
  null
  
)

export default component.exports